import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Contacts } from '../../model/contacts';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  private contactSelected: Contacts;

  constructor() { }

  public storeToLocalStorage(key: string, value: string) {
    localStorage.setItem(key, value);
  }

  public clearLocalStorage() {
    localStorage.clear();
  }

  public getAccessToken(): string {
    return localStorage.getItem("access_token");
  }

  public getUser() {
    var obj;

    obj = JSON.parse(localStorage.getItem("user"));

    return obj;
  }

  public getPermissions() {
    var obj;

    obj = localStorage.getItem("permissions");
    
    if (obj != null) {
      obj = JSON.parse(localStorage.getItem("permissions"))
      return obj;
    }

    return obj;
  }

  public getHeaders() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + this.getAccessToken(),
      }),
    };

    return httpOptions;
  }

  public getHead() {
    return new HttpHeaders({
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + this.getAccessToken(),
    })
  }


  public setContactSelected(obj: any) {
    sessionStorage.setItem("contactSelected", JSON.stringify(obj));
  }

  public getContactSelected() {
    return JSON.parse(sessionStorage.getItem("contactSelected"));
  }


}
